import { Moment } from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '../../../../../../../common/global/helpers';
import useMount from '../../../../../../../common/hooks/useMount';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Loader from '../../../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../../../common/widgets/LoadingSpinner';
import { EmployeeTimesheetSummaryModel } from '../../../../../models/EmployeeTimesheetSummaryModel';
import { resources } from '../../../../../resources/resources';
import { timesheetsAdminService } from '../../../../../services/timesheets-admin';

interface ITimesheetSummaryDialogProps {
  employeeName: string | undefined;
  employeeId: number | undefined;
  currentMonth: Moment;
  setShowTimesheetSummaryDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export enum TimeAndAttendanceTabs {
  TimeAndAttendance,
  Vacation,
}

export enum TimeAndAttendanceStep {
  Form,
  Confirm,
}

export const TimesheetSummaryDialog = (props: ITimesheetSummaryDialogProps) => {
  const [data, setData] = useState<EmployeeTimesheetSummaryModel[]>([]);

  const { t: translate } = useTranslation();
  const loadTimesheetSummaryDate = async (
    abortController?: AbortController,
  ) => {
    if (props.employeeId) {
      const result = await timesheetsAdminService.getTimesheetSummary(
        props.employeeId,
        props.currentMonth,
        {
          signal: abortController?.signal,
        },
      );

      if (abortController?.signal.aborted) {
        return;
      }

      if (!result.hasErrors) {
        setData(result.data);
      } else {
        showErrorToast(translate(resources.errors.generic));
      }
    }
  };

  useMount((abortController: AbortController | undefined) => {
    loadTimesheetSummaryDate(abortController);
  });

  return (
    <Dialog
      className={`attendance-dialog dialog-s`}
      showCloseIcon={true}
      closeOnClickOutside={false}
      closeDialog={() => {
        props.setShowTimesheetSummaryDialog(false);
      }}
    >
      <div className="dialog-content">
        <div className="dialog-title">
          {translate(resources.admin.timesheets.summaryDialog.title, {
            ['employeeName']: props.employeeName,
          })}
        </div>

        <Loader loading={!data || data.length == 0} loader={<LoadingSpinner />}>
          <div className="attendance-list">
            {data.map(d => {
              return (
                <div key={d.presenceTypeDescription}>
                  <span>
                    {translate(
                      resources.admin.timesheets.summaryDialog.description,
                      {
                        ['presenceTypeDescription']: d.presenceTypeDescription,
                      },
                    )}
                  </span>{' '}
                  <span>
                    {translate(resources.admin.timesheets.summaryDialog.value, {
                      ['nrDays']: d.nrDays,
                    })}
                  </span>
                </div>
              );
            })}
          </div>
        </Loader>
      </div>
      <div className="dialog-actions vertical">
        <button
          className="btn btn-outline"
          onClick={() => props.setShowTimesheetSummaryDialog(false)}
        >
          <span className="btn-text">
            {translate(resources.admin.timesheets.summaryDialog.close)}
          </span>
        </button>
      </div>
    </Dialog>
  );
};
